export default {
  en: {
    messages: {
      required: () => 'This field is required'
    }
  },
  vi: {
    messages: {
      required: () => 'Trường này không được bỏ trống'
    }
  }
}
